//
// locales/vanilla/cs.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/cs.json';
import localeData from 'react-intl/locale-data/cs.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
